import type { Board } from "../../board";
import { PRIORITY_DEFAULT, type ProcessableThing } from "../../interfaces";
import { Thing } from "../../thing";

export class TimedAction extends Thing implements ProcessableThing {
	static key = "TimedAction";
	timer: number;
	private action: () => void;

	constructor(timer: number = 0, action: () => void = () => {}) {
		super();
		this.timer = timer;
		this.action = action;
	}

	processTurn(board: Board): void {
		this.timer--;
		if (this.timer <= 0) {
			this.action();
			board.removeAtEndOfTurn(this);
		}
	}

	getProcessPriority(): number {
		return PRIORITY_DEFAULT;
	}

	serialize(): Record<string, unknown> {
		return {
			...super.serialize(),
			timer: this.timer,
		};
	}

	static deserialize(data: any): TimedAction {
		const t = new TimedAction(data.timer ?? 0);
		return t;
	}
}
